import React from 'react'
import * as S from './styled'

export type ProgressBarProps = {
  value: number
  max?: number
  height?: number
  barColor?: string
}

export const ProgressBar = ({ value, max = 100, height = 2, barColor }: ProgressBarProps) => (
  <S.Container $height={height}>
    <S.Bar
      data-testid="ProgressBar.Bar"
      $color={barColor}
      style={{ width: `${(value / max) * 100}%` }}
    />
  </S.Container>
)
